export const CONNECTION_TYPES_ENUM = Object.freeze({
  SELECT: -1,
  FTP: 0,
  BLOB: 1,
});

export const CONNECTION_TYPES_DATA = [
  { value: CONNECTION_TYPES_ENUM.SELECT, text: "Select a Connection Type" },
  { value: CONNECTION_TYPES_ENUM.FTP, text: "FTP" },
  { value: CONNECTION_TYPES_ENUM.BLOB, text: "Blob Storage" },
];